
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinwagleestatethane() {



const cardData = {
  keyword: 'Corporate Cab Services in Wagle Estate Thane',
  heading: 'eTravo: Reliable Corporate Cab Services in Wagle Estate Thane',
  headingDescription: `eTravo offers trusted and efficient corporate cab services in Wagle Estate Thane, designed to meet the dynamic transportation needs of businesses and employees in this busy industrial zone. Our service portfolio includes daily employee commutes, client pickups, executive travel, and shuttle services, all delivered with utmost professionalism. With GPS-tracked vehicles, experienced drivers, and customizable routes, we ensure timely, safe, and comfortable rides that keep your business operations running smoothly. Our corporate cab solutions are crafted to improve workforce punctuality and provide hassle-free, budget-friendly transport options for companies of all sizes.`,

  top: 'Key Industrial and Business Locations in Wagle Estate Thane Served by eTravo',
  topPlaces: [
    {
      title: 'Wagle Estate Industrial Area',
      description: `A major industrial hub hosting a wide array of manufacturing and service companies. eTravo facilitates efficient employee and client transport with reliable and frequent cab services across this zone.`
    },
    {
      title: 'Reliance Industrial Estate',
      description: `An important industrial estate known for diverse business units. Our corporate cabs provide safe and punctual transportation tailored to shift timings and business hours here.`
    },
    {
      title: 'Thane Belapur Road',
      description: `A key commercial corridor adjacent to Wagle Estate. We offer seamless connectivity for professionals and staff commuting between offices, ensuring hassle-free rides every day.`
    },
    {
      title: 'Godrej Industrial Complex',
      description: `A reputed industrial complex in the vicinity. eTravo’s fleet services employees and executives traveling to and from this business park with professionalism and care.`
    },
    {
      title: 'MSEZ (Maharashtra Special Economic Zone)',
      description: `A specialized zone fostering export-oriented industries. Our corporate shuttle and client transport services enhance operational efficiency for companies here.`
    }
  ],

  services: [
    {
      name: 'Wagle Estate Thane Corporate Cab Rentals',
      description: `Customized corporate cab rental packages designed to meet the diverse needs of companies operating in Wagle Estate. We provide fixed-term and flexible rentals for daily staff transportation, business meetings, and events, ensuring dependable mobility solutions.`
    },
    {
      name: 'Employee Transport Cab Wagle Estate',
      description: `Daily employee cab services with well-maintained, GPS-enabled vehicles and professional drivers. We accommodate varying shift schedules to ensure safe, on-time employee commutes across Wagle Estate industrial areas.`
    },
    {
      name: 'Business Cab Services Wagle Estate Thane',
      description: `Tailored cab services for business owners, field staff, and visiting clients. Our fleet includes sedans and SUVs for comfortable and timely travel, enhancing corporate image and operational efficiency.`
    },
    {
      name: 'Corporate Staff Cabs Wagle Estate',
      description: `Structured staff transportation solutions featuring multi-stop routes and shift-based scheduling. Our real-time tracking ensures managers can monitor fleet movement and improve staff commute reliability.`
    },
    {
      name: 'Reliable Corporate Cab Service Wagle Estate Thane',
      description: `Recognized for punctuality, safety, and customer-centric service, our corporate cabs maintain high standards of cleanliness and driver professionalism to guarantee a smooth ride experience.`
    },
    {
      name: 'AC Corporate Cabs Wagle Estate',
      description: `Fully air-conditioned vehicles that provide a comfortable and pleasant environment for employees and clients, suitable for all seasons including hot summers and rainy days.`
    },
    {
      name: 'Staff Pickup and Drop Cab Wagle Estate',
      description: `Efficient pickup and drop services aligned with company shift patterns and employee locations. Our scheduling optimizes routes to minimize waiting times and maximize safety.`
    },
    {
      name: 'Affordable Business Cab Rentals Wagle Estate Thane',
      description: `Flexible and budget-friendly cab rental plans catering to startups, SMEs, and large corporations. We offer customizable billing options and  to maximize cost efficiency.`
    },
    {
      name: 'Executive Cab Services Wagle Estate',
      description: `Premium cab services with luxury vehicles and professional chauffeurs for executives and VIP clients. We emphasize discretion, punctuality, and superior comfort for important business travel.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Wagle Estate Thane',
      description: `Convenient monthly rental plans for consistent employee transport needs. These include GPS tracking, shift-based routes, and comprehensive support to simplify corporate commute management.`
    },
    {
      name: 'Industrial Area Employee Transport Wagle Estate',
      description: `Coordinated transportation services designed specifically for employees working in the industrial zones of Wagle Estate, including multi-location pickups and drop-offs.`
    },
    {
      name: 'Corporate Client Cabs Wagle Estate Thane',
      description: `Professional and comfortable cab services for business meetings, client visits, and corporate events, ensuring timely arrivals and positive client impressions.`
    },
    {
      name: 'Business Meeting Cabs Wagle Estate Thane',
      description: `On-demand cab solutions for urgent or last-minute business meetings, allowing executives and staff to travel quickly and efficiently across Wagle Estate and adjoining areas.`
    },
    {
      name: 'Wagle Estate Industrial Area Cab Hire',
      description: `Dedicated cab hire for staff transport, inter-office travel, and special corporate events within Wagle Estate Industrial Area, emphasizing safety and convenience.`
    },
    {
      name: 'Corporate Shuttle Cabs Wagle Estate Thane',
      description: `Shuttle services designed for group transportation during meetings, training sessions, and other corporate functions, ensuring punctual pickups and comfortable rides.`
    }
  ],

  tableData: [
    ['Wagle Estate Thane Corporate Cab Rentals', 'Employee Transport Cab Wagle Estate'],
    ['Business Cab Services Wagle Estate Thane', 'Corporate Staff Cabs Wagle Estate'],
    ['Reliable Corporate Cab Service Wagle Estate Thane', 'AC Corporate Cabs Wagle Estate'],
    ['Staff Pickup and Drop Cab Wagle Estate', 'Affordable Business Cab Rentals Wagle Estate Thane'],
    ['Executive Cab Services Wagle Estate', 'Monthly Corporate Cab Rentals Wagle Estate Thane'],
    ['Industrial Area Employee Transport Wagle Estate', 'Corporate Client Cabs Wagle Estate Thane'],
    ['Business Meeting Cabs Wagle Estate Thane', 'Wagle Estate Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Wagle Estate Thane', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Specialized Cab Services for Wagle Estate Thane",
    "WhyChoosedescription": "eTravo provides high-reliability corporate cab services tailored for businesses located in Wagle Estate, Thane—one of the city's most prominent industrial and commercial hubs. Whether you're operating from IT parks, manufacturing units, or corporate offices, our services ensure streamlined employee transportation, increased workforce punctuality, and reduced operational delays. We focus on delivering a professional, safe, and comfortable commute experience aligned with corporate expectations."
  },
  {
    "WhyChooseheading": "Fleet Variety for All Business Needs",
    "WhyChoosedescription": "Our fleet includes sedans for executive transport, MUVs for group commutes, and hatchbacks for compact travel needs—each vehicle fully equipped with air-conditioning, GPS tracking, and safety features. This flexibility allows us to meet the diverse mobility requirements of companies operating in Wagle Estate and neighboring industrial areas."
  },
  {
    "WhyChooseheading": "Trained Drivers with Area Expertise",
    "WhyChoosedescription": "Our drivers are familiar with Wagle Estate’s routes, peak traffic hours, and alternate corridors, ensuring minimal delays and efficient navigation. Additionally, they are trained in corporate etiquette and safety protocols, offering your employees a respectful and professional experience every time."
  },
  {
    "WhyChooseheading": "Customizable Booking and Shift Scheduling",
    "WhyChoosedescription": "With multiple businesses in Wagle Estate running in shifts or hybrid formats, we provide complete scheduling flexibility—including daily, weekly, and shift-based bookings. Our system supports recurring ride setups, emergency transport, and multi-point pickups/drop-offs."
  },
  {
    "WhyChooseheading": "Real-Time Ride Tracking and Monitoring",
    "WhyChoosedescription": "All our cabs are GPS-enabled and monitored live, giving your HR or operations team complete control and visibility. From live trip tracking to ETA updates and driver behavior monitoring, our system ensures security and efficiency across every ride."
  },
  {
    "WhyChooseheading": "Digital Invoicing with Detailed Billing",
    "WhyChoosedescription": "We offer fully transparent billing solutions with GST-compliant monthly invoices, complete trip logs, and detailed fare breakdowns. This simplifies financial tracking and supports accurate budget forecasting for employee transportation."
  },
  {
    "WhyChooseheading": "Strict Hygiene and Safety Standards",
    "WhyChoosedescription": "eTravo adheres to high hygiene and safety protocols. Vehicles are sanitized daily, and our drivers follow health checks, mask mandates, and cleanliness guidelines. These efforts help ensure a secure travel environment for your team."
  },
  {
    "WhyChooseheading": "Dedicated Account Manager for Corporate Clients",
    "WhyChoosedescription": "Every corporate client is assigned a dedicated account manager who handles day-to-day coordination, customized route planning, special requests, and real-time issue resolution—ensuring a smooth experience tailored to your organization’s unique needs."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas do your services cover in and around Wagle Estate?",
      answer: "We cover the entire Wagle Estate region along with nearby locations like Ghodbunder Road, Pokhran, and Eastern Express Highway corridors."
    },
    {
      question: "Do you offer shift-based employee transport scheduling?",
      answer: "Yes, we provide fixed, rotating, and custom shift-based scheduling with flexible pickup and drop timings suited for factory and office operations."
    },
    {
      question: "Can we get monthly invoices with trip logs and summaries?",
      answer: "Absolutely. We provide monthly, GST-compliant invoices with detailed trip records for ease of reconciliation and expense reporting."
    },
    {
      question: "Are your drivers trained to handle corporate requirements?",
      answer: "Yes, our drivers are trained in safe driving practices, route familiarity, and maintaining corporate etiquette throughout every journey."
    },
    {
      question: "How do you ensure passenger safety in high-traffic zones?",
      answer: "We use live GPS tracking, background-verified drivers, and enforce hygiene and traffic compliance measures to ensure ride safety."
    },
    {
      question: "Is there a support contact for managing bookings and escalations?",
      answer: "Yes, a dedicated account manager is provided for each corporate client to manage bookings, optimize routes, and resolve any issues promptly."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sanjay Iyer",
    designation: "Facilities Head, TechLine India Pvt Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab service has been instrumental in improving our shift operations in Wagle Estate. Timely service and great driver conduct are their strengths.”"
  },
  {
    name: "Ms. Rucha Gokhale",
    designation: "HR Business Partner, NovaWare Systems",
    rating: [1, 1, 1, 1, 1],
    text: "“Reliable, professional, and easy to manage. eTravo is our go-to partner for corporate transportation in and around Wagle Estate.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Wagle Estate Thane",
  "image": "https://www.etravo.in/images/keyword/cab-service-wagle-estate-thane.jpg",
  "description": "Reliable corporate cab service in Wagle Estate Thane offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-wagle-estate-thane"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Wagle Estate Thane | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Wagle Estate Thane for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinwagleestatethane;